import React, { useState } from 'react';
interface MortgageInputFormProps {
  onSubmit: (formData: any) => void;
  initialValues: any;
}
export function MortgageInputForm({
  onSubmit,
  initialValues
}: MortgageInputFormProps) {
  const [formData, setFormData] = useState(initialValues);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'amount' || name === 'downPayment' ? parseInt(value) : value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };
  return <div className="bg-white rounded-lg p-6 border border-neutral-200" data-id="element-492">
      <h3 className="text-lg font-medium text-neutral-900 mb-4" data-id="element-493">
        Mortgage Details
      </h3>
      <form onSubmit={handleSubmit} data-id="element-494">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-495">
          <div data-id="element-496">
            <label htmlFor="amount" className="block text-sm font-medium text-neutral-700 mb-1" data-id="element-497">
              Mortgage Amount ($)
            </label>
            <input type="number" id="amount" name="amount" value={formData.amount} onChange={handleInputChange} className="w-full p-2 border border-neutral-300 rounded-md" min="10000" step="10000" required data-id="element-498" />
          </div>
          <div data-id="element-499">
            <label htmlFor="downPayment" className="block text-sm font-medium text-neutral-700 mb-1" data-id="element-500">
              Down Payment ($)
            </label>
            <input type="number" id="downPayment" name="downPayment" value={formData.downPayment} onChange={handleInputChange} className="w-full p-2 border border-neutral-300 rounded-md" min="0" step="5000" required data-id="element-501" />
          </div>
          <div data-id="element-502">
            <label htmlFor="amortization" className="block text-sm font-medium text-neutral-700 mb-1" data-id="element-503">
              Amortization (Years)
            </label>
            <select id="amortization" name="amortization" value={formData.amortization} onChange={handleInputChange} className="w-full p-2 border border-neutral-300 rounded-md" required data-id="element-504">
              <option value="15" data-id="element-505">15 Years</option>
              <option value="20" data-id="element-506">20 Years</option>
              <option value="25" data-id="element-507">25 Years</option>
              <option value="30" data-id="element-508">30 Years</option>
            </select>
          </div>
          <div data-id="element-509">
            <label htmlFor="propertyType" className="block text-sm font-medium text-neutral-700 mb-1" data-id="element-510">
              Property Type
            </label>
            <select id="propertyType" name="propertyType" value={formData.propertyType} onChange={handleInputChange} className="w-full p-2 border border-neutral-300 rounded-md" required data-id="element-511">
              <option value="Single Family" data-id="element-512">Single Family Home</option>
              <option value="Condo" data-id="element-513">Condominium</option>
              <option value="Townhouse" data-id="element-514">Townhouse</option>
              <option value="Multi-Family" data-id="element-515">Multi-Family (2-4 units)</option>
            </select>
          </div>
          <div data-id="element-516">
            <label htmlFor="propertyUse" className="block text-sm font-medium text-neutral-700 mb-1" data-id="element-517">
              Property Use
            </label>
            <select id="propertyUse" name="propertyUse" value={formData.propertyUse} onChange={handleInputChange} className="w-full p-2 border border-neutral-300 rounded-md" required data-id="element-518">
              <option value="Primary Residence" data-id="element-519">Primary Residence</option>
              <option value="Secondary Home" data-id="element-520">Secondary Home</option>
              <option value="Investment" data-id="element-521">Investment Property</option>
            </select>
          </div>
        </div>
        <div className="flex justify-end" data-id="element-522">
          <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors" data-id="element-523">
            Get Mortgage Rates
          </button>
        </div>
      </form>
    </div>;
}